import Tabla from "./tabla";
import Table from "./dataTable";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";

export default withRouter(withApollo(Tabla));
export const DataTable = withRouter(withApollo(Table));
